export default "__VITE_ASSET__DscyYc_N__"